

export const types = {
    login: '[auth] Login',
    logout: '[auth] Logout',
}


export const PARTICIPANT_WORK = {
    id: '',
    ownerId: '',
    title: '',
    authors: [],
    status: '', // 'validado', 'pendiente', 'revisar'
    keywords: [],
    url: '',
    method: '', // 'poster', 'e-poster', 'ponencia', 'video'
}


export const author = {
    id: '',
    names: '',
    lastnames: '',
    institution: '',
    email: '',
}